import { Reveal, MaskedLine } from "@/components/Reveal";
import { usePageTitle } from "@/lib/usePageTitle";
import { SITE } from "@/lib/content";

const SECTIONS = [
  {
    title: "Our commitment",
    body: "This website aims to meet WCAG 2.1 Level AA standards. Pages use clear headings, readable typography, strong colour contrast, visible focus indicators, and labels on all form fields, so the site can be navigated by keyboard and used with screen readers.",
  },
  {
    title: "Using this website",
    body: "You can navigate every page and form using only a keyboard, increase text size through your browser without losing content, and use screen-reader software — images carry alternative text and interactive elements carry accessible labels. If anything is difficult to use, please let us know.",
  },
  {
    title: "Online sessions",
    body: "Online therapy is available by secure video for anyone who finds travel difficult — whether because of mobility, health, caring responsibilities or distance. You only need a private space and a phone, tablet or computer.",
  },
  {
    title: "Visiting the Marino practice",
    body: `The practice is located in Marino, Dublin 3. If you have specific access needs — for example step-free access, seating adjustments, or a quieter arrival time — please mention it when booking via ${SITE.email} or ${SITE.phone}, and every reasonable effort will be made to accommodate you.`,
  },
  {
    title: "Feedback",
    body: "Accessibility is an ongoing effort. If you encounter any barrier on this website or in arranging a session, please get in touch — your feedback directly shapes improvements.",
  },
];

const Accessibility = () => {
  usePageTitle("Accessibility", "Accessibility statement for the Brian Boland Psychotherapy & Counselling website and Marino practice.");
  return (
    <div data-testid="accessibility-page">
      <section className="mx-auto max-w-3xl px-5 pb-16 pt-16 sm:px-8 lg:pt-24">
        <Reveal y={12}><p className="eyebrow">Accessibility</p></Reveal>
        <h1 className="mt-6 font-serif text-4xl font-medium leading-[1.12] tracking-tight text-[#1E2723] sm:text-5xl">
          <MaskedLine delay={0.15}>Therapy should be</MaskedLine>
          <MaskedLine delay={0.3} className="italic text-[#527363]">open to everyone</MaskedLine>
        </h1>
        <Reveal delay={0.5}>
          <p className="mt-7 text-base leading-relaxed text-[#4A5750] sm:text-lg">
            This statement explains the accessibility of this website and the practical steps taken to make therapy accessible, online and in person.
          </p>
        </Reveal>
      </section>
      <section className="mx-auto max-w-3xl space-y-5 px-5 pb-24 sm:px-8">
        {SECTIONS.map((s, i) => (
          <Reveal key={s.title} delay={0.05 * i}>
            <article className="soft-card p-7" data-testid={`accessibility-section-${i}`}>
              <h2 className="font-serif text-xl font-medium text-[#1E2723]">{s.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-[#54645B]">{s.body}</p>
            </article>
          </Reveal>
        ))}
      </section>
    </div>
  );
};

export default Accessibility;
